<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                Справочники
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <div class="title">Доп. услуги</div>
                      <router-link to="/directories/additional-categories/new">
                        <div class="add-table-string"><i>+</i>Добавить строку</div>
                      </router-link>
                    </div>
                    <table cellpadding="0" cellspacing="0">
                      <thead>
                      <tr>
                        <td>Наименование доп. услуги</td>
                        <td>Цена, руб.</td>
                        <td>Тип исполнителя</td>
                        <td>Зар. плата, руб.</td>
                        <td>Является упаковкой</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr title="Изменить" v-for="category in filteredAdditionalCategories" @value="category"
                          @key="category.id" @click="openAdditionalCategory(category.id)" v-if="!category.removed">
                        <td class="name">{{ category.name }}</td>
                        <td>{{ category.price }}</td>
                        <td>{{ category.workerTypes }}</td>
                        <td>{{ category.salary }}</td>
                        <td v-if="category.packing"><img src="../image/check-orange.png"></td>
                        <td v-else></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'

    export default {
  name: 'AdditionalCategories',
  components: {
    MenuDispatcher,
    HeaderDispatcher
  },

  data () {
    return {
      additionalCategories: []
    }
  },

  computed: {
    filteredAdditionalCategories () {
      return this.additionalCategories.sort((a) => a.shippingPacking ? -1 : 1)
    }
  },

  mounted () {
    api
      .getAdditionalCategories()
      .then(additionalCategories => {
        if (additionalCategories) {
          this.additionalCategories = []
          this.additionalCategories = additionalCategories
        }
      })

    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    openAdditionalCategory (id) {
      this.$router.push({ name: 'AdditionalCategory', params: { id: id } })
    }
  }
}
</script>
